{
  "colorFormat": "Format de couleur",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "TSL",
  "rgb": "RVB"
}
